import Vue from 'vue';

import GeolocationPopup from './GeolocationPopup.vue';
import { parseGeolocationPayload } from '../utils/parseLiquidPayload.js';

const root = document.querySelector('#geolocation-popup');

if (root) {
  const { localization, settings, translations } = parseGeolocationPayload(root);

  new Vue({
    render(h) {
      return h(GeolocationPopup, {
        props: {
          localization,
          settings,
          translations,
        },
      });
    },
  }).$mount('#geolocation-popup');
}
